import { render, staticRenderFns } from "./ui_select.vue?vue&type=template&id=c1156ea4&scoped=true&"
import script from "./ui_select.vue?vue&type=script&lang=js&"
export * from "./ui_select.vue?vue&type=script&lang=js&"
import style0 from "./ui_select.vue?vue&type=style&index=0&id=c1156ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1156ea4",
  null
  
)

export default component.exports